import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUserInfo } from '@/hooks'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import { useSendCode } from '@/hooks/useSendCode'
import { Toast } from 'react-vant'
import { APIWeb } from '@/api/index'

export default React.memo(function VerNewAccountCode() {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { state } = useLocation()
    const { actions } = useUserInfo()
    console.log('verNewAccount', state)
    const { sendCode, sendCodeLoading } = useSendCode()
    const [submitLoading, setSubmitLoading] = useState(false)
    // 从 URL 查询参数读取验证码数据
    const handleResendCode = useCallback(async () => {
        await sendCode({
            account: state?.newAccount || '',
            scene: 'change_account',
        })
    }, [sendCode, state?.newAccount])

    // 提交新账户校验
    const handleSubmit = useCallback(async (code: string) => {
        setSubmitLoading(true)
        try {
            const data = await APIWeb.verifyNewAccountCode({
                account: state?.newAccount || '',
                verify_key: state?.verify_key || '',
                code,
            })
            if (data) {
                // 刷新用户信息
                actions.fetchUserInfo();
                Toast.success({
                    message: t('验证成功'),
                    onClose: () => {
                        navigate('/change-account/change-success')
                    }
                })
            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setSubmitLoading(false)
        }
    }, [actions, navigate, sendCode, sendCodeLoading, state?.newAccount, state?.verify_key])
    return (
        <PageLayout>
            <Header leftChildren={<Back />} />
            {/* Content */}
            <div className="px-6 py-6">
                <VerificationCodeInput
                    account={state?.newAccount || ''}
                    resendLoading={sendCodeLoading}
                    submitLoading={submitLoading}
                    onResendCode={handleResendCode}
                    onSubmit={handleSubmit}
                    submitButtonText={t('立即验证')}
                />

            </div>
        </PageLayout>
    )
})
